import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

function Loader() {
  return (
    <motion.div
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'var(--ink)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 99999,
      }}
    >
      <div style={{ textAlign: 'center', width: 'min(320px, 80vw)' }}>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 800, marginBottom: 22 }}
        >
          Prakash<span style={{ color: 'var(--aqua)' }}>.</span>C
        </motion.div>
        <div style={{ height: 4, borderRadius: 8, overflow: 'hidden', background: 'rgba(255,255,255,0.08)' }}>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '100%' }}
            transition={{ duration: 1.1, ease: 'easeInOut' }}
            style={{
              height: '100%',
              background: 'linear-gradient(90deg, var(--aqua), var(--rose), var(--sun), var(--lime))',
              backgroundSize: '220% 220%',
              animation: 'gradientShift 3s ease infinite',
            }}
          />
        </div>
        <p style={{ marginTop: 14, color: 'var(--muted)', fontFamily: 'var(--font-display)', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase' }}>
          Loading premium work
        </p>
      </div>
    </motion.div>
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          whileHover={{ y: -3 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
          style={{
            position: 'fixed',
            right: 24,
            bottom: 24,
            width: 48,
            height: 48,
            zIndex: 500,
            border: '1px solid rgba(255,255,255,0.22)',
            color: 'var(--ink)',
            background: 'linear-gradient(135deg, var(--aqua), var(--sun))',
            cursor: 'pointer',
            fontFamily: 'var(--font-display)',
            fontWeight: 800,
          }}
        >
          UP
        </motion.button>
      )}
    </AnimatePresence>
  );
}

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1250);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence>
        {loading && <Loader key="loader" />}
      </AnimatePresence>

      {!loading && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.55 }}>
          <Navbar />
          <main>
            <Hero />
            <About />
            <Skills />
            <Services />
            <Portfolio />
            <Testimonials />
            <Blog />
            <Contact />
          </main>
          <Footer />
          <BackToTop />
        </motion.div>
      )}
    </>
  );
}
